module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/29-d2eff7fe68a4a3632a70316ed096322f.jpg";